import React, { useMemo, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import useBookingsDataDetail from "@/utils/queries/hooks/useBookingsDataDetail";
import styles from "../../../styles/booking/paymentSection.module.scss";

const PaymentSection: React.FC<{ bookingId: string }> = ({ bookingId }) => {
    const { data: bookingsDetail } = useBookingsDataDetail(bookingId);
    const [details1, setDetails1] = useState(false);
    const [details2, setDetails2] = useState(false);
    const [details3, setDetails3] = useState(false);

    const getTravellerString = (
        numberOfPeople: number,
        singularLabel: string,
        pluralLabel: string
    ) => {
        if (!numberOfPeople) {
            return "";
        }

        return `${numberOfPeople} ${
            numberOfPeople > 1 ? pluralLabel : singularLabel
        }`;
    };

    const discountPrice = useMemo(() => {
        const totalWithoutDiscount = bookingsDetail?.rooms?.reduce(
            (total, room) => total + +room.price,
            0
        );
        return totalWithoutDiscount && bookingsDetail?.totalAmount
            ? totalWithoutDiscount - +bookingsDetail.totalAmount
            : 0;
    }, [bookingsDetail]);

    return (
        <div>
            <p className={styles.title} style={{ display: "none" }}>
                Installment Payments
            </p>
            <div className={styles.container} style={{ display: "none" }}>
                <div className={styles.line}>
                    <div className={styles.sxColumn}>
                        <Image
                            src="/images/checkIcon.svg"
                            width={40}
                            height={40}
                            alt="checkIcon"
                            className={styles.image}
                        />

                        <div className={styles.installmentLine}>
                            <span className={styles.installment}>
                                Fisrt installment{" "}
                                <span className={styles.installmentPrice}>
                                    $699
                                </span>
                            </span>

                            {details1 ? (
                                <span className={styles.due}>
                                    Due by 28/04/2023
                                </span>
                            ) : (
                                ""
                            )}
                        </div>
                    </div>
                    <div className={styles.dxColumn}>
                        <span
                            className={styles.details}
                            onClick={() => setDetails1(!details1)}
                        >
                            details{" "}
                            <Image
                                src="/images/detailsIcon.svg"
                                height={20}
                                width={20}
                                alt="detailsIcon"
                                className={
                                    details1
                                        ? styles.detailsIconActive
                                        : styles.detailsIconDeactivated
                                }
                            />
                        </span>
                        <span className={styles.paid}>Paid</span>
                    </div>
                </div>
                <div className={styles.line}>
                    <div className={styles.sxColumn}>
                        <Image
                            src="/images/deleteIcon.svg"
                            width={40}
                            height={40}
                            alt="deleteIcon"
                            className={styles.imageDelete}
                        />

                        <div className={styles.installmentLine}>
                            <span className={styles.installment}>
                                Second installment{" "}
                                <span className={styles.installmentPrice}>
                                    $1299
                                </span>
                            </span>

                            {details2 ? (
                                <span className={styles.due}>
                                    Due by 28/04/2023
                                </span>
                            ) : (
                                ""
                            )}
                        </div>
                    </div>
                    <div className={styles.dxColumn}>
                        <span
                            className={styles.details}
                            onClick={() => setDetails2(!details2)}
                        >
                            details{" "}
                            <Image
                                src="/images/detailsIcon.svg"
                                height={20}
                                width={20}
                                alt="detailsIcon"
                                className={
                                    details2
                                        ? styles.detailsIconActive
                                        : styles.detailsIconDeactivated
                                }
                            />
                        </span>
                        <span className={styles.dueButton}>Due</span>
                    </div>
                </div>
                <div className={styles.line}>
                    <div className={styles.sxColumn}>
                        <Image
                            src="/images/deleteIcon.svg"
                            width={40}
                            height={40}
                            alt="deleteIcon"
                            className={styles.imageDelete}
                        />

                        <div className={styles.installmentLine}>
                            <span className={styles.installment}>
                                Third installment{" "}
                                <span className={styles.installmentPrice}>
                                    $1299
                                </span>
                            </span>

                            {details3 ? (
                                <span className={styles.due}>
                                    Due by 28/04/2023
                                </span>
                            ) : (
                                ""
                            )}
                        </div>
                    </div>
                    <div className={styles.dxColumn}>
                        <span
                            className={styles.details}
                            onClick={() => setDetails3(!details3)}
                        >
                            details{" "}
                            <Image
                                src="/images/detailsIcon.svg"
                                height={20}
                                width={20}
                                alt="detailsIcon"
                                className={
                                    details3
                                        ? styles.detailsIconActive
                                        : styles.detailsIconDeactivated
                                }
                            />
                        </span>
                        <span className={styles.dueButton}>Due</span>
                    </div>
                </div>
            </div>

            <p className={styles.title}>Prices&apos; details</p>
            <div className={styles.container}>
                {bookingsDetail?.rooms?.map((element, index) => (
                    <div className={styles.line}>
                        <div
                            className={styles.room}
                            style={{ textTransform: "capitalize" }}
                        >{`${index + 1}º room: ${
                            element.type
                        } x ${getTravellerString(
                            element.adults,
                            "adult",
                            "adults"
                        )} ${
                            element.children.length ? "," : ""
                        } ${getTravellerString(
                            element.children.length,
                            "child",
                            "children"
                        )}`}</div>
                        <div
                            className={styles.priceRoom}
                        >{`${element.price} € `}</div>
                    </div>
                ))}
                {discountPrice !== 0 && (
                    <div className={styles.line}>
                        <div
                            className={styles.room}
                            style={{ textTransform: "capitalize" }}
                        >
                            Coupon Discount
                        </div>
                        <div className={styles.priceRoom}>{`- ${Number(
                            discountPrice
                        ).toFixed(2)} € `}</div>
                    </div>
                )}
                <div className={styles.line}>
                    <div
                        className={styles.room}
                        style={{
                            textTransform: "capitalize",
                            fontWeight: "bold",
                            color: "black",
                        }}
                    >
                        Total
                    </div>
                    <div
                        className={styles.priceRoom}
                    >{`${bookingsDetail?.totalAmount} € `}</div>
                </div>
            </div>

            <div className={styles.containerNeedHelp}>
                <p className={styles.text}>
                    Need Help?{" "}
                    <span>
                        <Link href="/faq" className={styles.textLink}>
                            Let`s talk about it.
                        </Link>
                    </span>
                </p>
            </div>
        </div>
    );
};

export default PaymentSection;
